import request from "./request";
import authorizationStore from "./authorizationStore";
import envConfig from "../../../envConfig.json";

// import { waitWithProb } from "../Utils";

// -- Stage --
// const URL_API_AI = "https://api.rxweb-pre.com/companionai"; //"https://smart-companion-services-dev.reds.rxweb-pre.com"; //"https://test.aiprofile.rx-france.com";
// const URL_API_AI_WS = "api.rxweb-pre.com/companionai"; //"smart-companion-services-dev.reds.rxweb-pre.com";
// const URL_API_GRAPHQL = "https://api.rxweb-pre.com/";

// -- Prod --
const URL_API_AI = envConfig.URL_API_AI;
const URL_API_AI_WS = "api.reedexpo.com/companionai";
const URL_API_GRAPHQL = envConfig.GRAPHQL_URL;

// TODO: FIX - the wrong exhId is sometimes returned, causing futher errors (only with sharers)
// This is likely due to a mismatch in the eventEditionId or user context when fetching the exhibiting organisations.
const fetchUserExhibitingOrganisations = async (eventEditionId, locale) => {
  const query = `{
    userExhibitingOrganisations(eventEditionId: "${eventEditionId}", locale: "${locale}") {
      eventEditionId
      eventEditionName
      exhibitingOrganisationId
      companyName
      organisationId
    }
  }`;

  try {
    const response = await request.graphqlRequest(URL_API_GRAPHQL, query, true);
    // console.log("fetchUserExhibitingOrganisations:");
    // console.log(response);
    return response;
  } catch (error) {
    throw new Error(`Fetch failed: ${error.message}`);
  }
};

const fetchExhibitorStatus = async (exhId) => {
  const exhCheckUrl = `${URL_API_AI}/get_show_popup?exh_id=${encodeURIComponent(
    exhId,
  )}`;

  // const params = { url: urlToScrape };
  try {
    const response = await request.performFetch(exhCheckUrl, "GET");

    if (response.status > 200) {
      throw new Error("Network response was not ok " + response.statusText);
    }

    const data = await response.json(); // Await the JSON response
    // console.log("Exhibitor Status result:", data); // Log the data
    return data;
  } catch (error) {
    console.error(
      "There was a problem with the fetch exh status operation:",
      error,
    );
    return error;
  }
};

async function pollExhibitorStatus(exhId) {
  const startTime = Date.now();
  const maxDuration = 90_000;
  const interval = 10_000;

  while (Date.now() - startTime < maxDuration) {
    const res = await fetchExhibitorStatus(exhId);

    switch (res.exh_status) {
      case "OK":
      case "ERROR":
        return res;
      case "RUNNING":
        break;
      default:
        throw new Error(`Unknown status: ${res.exh_status}`);
    }

    await new Promise((resolve) => setTimeout(resolve, interval));
  }

  return { status: "TIMEOUT", exhId };
}

// TODO: Fix as the wrong exhId is sometimes sent, causing futher errors (only with sharers)
const fetchIntelligentProfile = async (urlToScrape, exhId) => {
  const scrapeUrl = `${URL_API_AI}/mutation_graphql_api?url=${encodeURIComponent(
    urlToScrape,
  )}&exh_id=${exhId}`;

  try {
    const response = await request.performFetch(scrapeUrl, "POST", null);

    // Handle 504 timeout → poll until complete
    if (response.status === 504) {
      const poll_response = await pollExhibitorStatus(exhId);

      switch (poll_response.exh_status) {
        case "OK":
          return [true, "updated after Timeout"];
        case "ERROR":
          return [false, "error after Timeout"];
        case "TIMEOUT":
          return [false, "TIMEOUT"];
        default:
          return [false, `Unknown status: ${poll_response.exh_status}`];
      }
    }

    // Any other HTTP error
    if (response.status > 200) {
      throw new Error("Network response was not ok " + response.statusText);
    }

    // Normal successful case
    const data = await response.json();
    return data;
  } catch (error) {
    if (
      error instanceof TypeError &&
      error.message.includes("Failed to fetch")
    ) {
      console.warn("Network timeout / CORS issue — treating as 504");
      const poll_response = await pollExhibitorStatus(exhId);

      switch (poll_response.exh_status) {
        case "OK":
          return [true, "updated after Timeout"];
        case "ERROR":
          return [false, "error after Timeout"];
        case "TIMEOUT":
          return [false, "TIMEOUT"];
        default:
          return [false, `Unknown exh_status: ${poll_response.exh_status}`];
      }
    }

    console.error("There was a problem with the fetch operation:", error);
    return [false, error];
  }
};

const fetchIntelligentProfileWS = async (urlToScrape, exhId) => {
  const token = await authorizationStore.getToken();

  return new Promise((resolve, reject) => {
    const protocol = window.location.protocol === "https:" ? "wss" : "ws";
    const wsUrl = `${protocol}://${URL_API_AI_WS}/mutation_graphql_api_ws`;
    const socket = new WebSocket(wsUrl);

    socket.onopen = () => {
      socket.send(
        JSON.stringify({
          url: urlToScrape,
          exh_id: exhId,
          token: token,
        }),
      );
    };

    socket.onmessage = (event) => {
      const data = JSON.parse(event.data);

      if (data.success) {
        resolve([true, data.data]); // success tuple
        socket.close();
      } else if (data.error) {
        resolve([false, data.error]); // failure tuple
        socket.close();
      } else {
        // Optional intermediate status (e.g., "Validation started...")
        console.log("Progress update:", data.message);
      }
    };

    socket.onerror = (event) => {
      console.error("🚨 fetchIntelligentProfileWS - onError:", event);
      reject(new Error("WebSocket connection failed"));
    };

    socket.onclose = () => {
      // Optional: handle if needed
    };
  });
};

export {
  fetchUserExhibitingOrganisations,
  fetchIntelligentProfile,
  fetchIntelligentProfileWS,
  fetchExhibitorStatus,
};
